'use strict';

import 'angular';

import { reverseUrl } from 'utils/django';
import { findByEquality, findByUUID } from 'utils/find';

import versioner from 'incidents/versions/versioner';
import noShopNoDisband from 'incidents/versions/standard_response/no_shop_no_disband';

function getVersion(incident) {
  const v = versioner[incident.version];
  if (v) {
    return v;
  } else {
    return {
      process: noShopNoDisband,
    }
  }
}

export default function ($log, $http, $window, $timeout, pusher) {
  'ngInject';

  var vm = this;

  function mergeIncidentData(incident, data) {
    if (data.extra_data && incident.extra_data) {
      Object.keys(incident.extra_data).forEach(function (prop) {
        delete incident.extra_data[prop];
      });
    }
    angular.merge(incident, data);
  }

  vm.get = function get(incident, ignoreUpdates) {
    console.log('Fetching incident', incident.uuid);
    var url = reverseUrl('incidents:incident-detail', { uuid: incident.uuid });
    return $http.get(url).then(getSuccess, getError);

    function getSuccess(response) {
      mergeIncidentData(incident, response.data);
      vm.process(incident);
      if (!ignoreUpdates) subscribe(incident);
      return incident;
    }

    function getError(response) {
      $log.error(response);
    }
  };

  let _sttPromise;
  function _updateStateTimeDiff(incident) {
    console.log('Updating state time diff');
    if (_sttPromise) $timeout.cancel(_sttPromise);
    incident.stateTimeDiff = (new Date() - new Date(incident.stateTime)) / 1000;
    if (incident.stateTimeDiff > 60) return;
    _sttPromise = $timeout(() => {
      _updateStateTimeDiff(incident);
    }, 1000);
  }

  vm.process = function (incident) {
    incident.processed = true;

    try {
      getVersion(incident).process(incident);
      incident.after_hours = (
        /.*after_hours/.test(incident.version) ||
        /.*_ah/.test(incident.version)
      )
    } catch (e) {
      $log.error(e);
      incident.state = 'error';
      incident.stateTime = new Date();
    }

    incident.isQa = false
    if (incident.entity) {
      incident.isQa = incident.entity.name == "Daupler Quality Assurance";
    }

    try {
      incident.hasActiveHold = false;
      if (incident.holds) {
        const releaseTimes = [];
        for (const h of incident.holds) {
          if (h.time_released === null) {
            incident.hasActiveHold = true;
            break;
          } else {
            releaseTimes.push(new Date(h.time_released));
          }
        }
        if (!incident.hasActiveHold && releaseTimes.length > 0) {
          const latestReleaseTime = Math.max(...releaseTimes);
          const relasedAgoSeconds = (new Date() - new Date(latestReleaseTime));
          const extraHoldMs = 10000;
          $log.info(
            `relasedAgoSeconds: ${relasedAgoSeconds}, extraHoldMs: ${extraHoldMs}`,
          );
          if (relasedAgoSeconds < extraHoldMs) {
            incident.hasActiveHold = true;
            $timeout(() => {
              vm.get(incident, true);
            }, extraHoldMs);
          }
        }
      }
    } catch (e) {
      $log.error(e);
    }

    incident.hide = incident.isQa || incident.hasActiveHold;

    _updateStateTimeDiff(incident);

    var geoLog = incident.log.filter(function (logEntry) {
      return logEntry.lat && logEntry.lng;
    });
    for (var i = 0, nbEntries = geoLog.length; i < nbEntries; i++) {
      // Give a link to a static map showing the current location
      var logEntry = geoLog[i];

      // Give a link to a map showing the path of the updated locations up
      // until that point
      if (i == 0) {
        logEntry.mapUrl = 'https://www.google.com/maps/search/?api=1';
        logEntry.mapUrl += `&query=${logEntry.lat},${logEntry.lng}`;
      } else {
        var originEntry = geoLog[0];
        var waypointsLog = geoLog.filter(function (entry) {
          return originEntry.time < entry.time && entry.time < logEntry.time;
        });
        var waypoints = waypointsLog.map(function (entry) {
          return `${entry.lat},${entry.lng}`;
        }).join('|');
        logEntry.mapUrl = 'https://www.google.com/maps/dir/?api=1';
        logEntry.mapUrl += '&travelmode=driving';
        logEntry.mapUrl += `&origin=${originEntry.lat},${originEntry.lng}`;
        logEntry.mapUrl += `&destination=${logEntry.lat},${logEntry.lng}`;
        if (waypoints) logEntry.mapUrl += `&waypoints=${waypoints}`;
      }
    }
    // https://www.google.com/maps/dir/?api=1&origin=Paris,France&destination=Cherbourg,France&travelmode=driving&waypoints=Versailles,France%7CChartres,France%7CLe+Mans,France%7CCaen,France
  }

  function subscribe(incident) {
    var channel = pusher.subscribe('presence-incident-' + incident.uuid);

    // Debug all events
    channel.bind_global(function () {
      $log.debug(arguments);
    });

    var subscribed = false;
    channel.$bind('pusher:subscription_succeeded', subscriptionHandler)

    channel.$bind('updated', updatedHandler);
    channel.$bind('deleted', deletedHandler);

    var relatedFields = [
      'log',
      'locations',
      'team',
      'forms',
      'labels',
      'notes',
      'files',
      'tags',
      'integrations',
    ];
    relatedFields.forEach(function (field) {
      channel.$bind(field + '_added', objectAddedHandler.bind(null, field));
      channel.$bind(field + '_updated', objectUpdatedHandler.bind(null, field));
      channel.$bind(field + '_deleted', objectDeletedHandler.bind(null, field));
    });

    channel.$bind('location_contact_added', locationContactAddedHandler);
    channel.$bind('location_contact_updated', locationContactUpdatedHandler);
    channel.$bind('location_contact_deleted', locationContactDeletedHandler);

    function subscriptionHandler(data) {
      if (subscribed) {
        vm.get(incident, true)
      } else {
        subscribed = true;
        incident.channel = channel;
      }
    }

    channel.$bind('incident_holds_updated', () => {
      vm.get(incident, true);
    })

    function updatedHandler(data) {
      if (data) {
        mergeIncidentData(incident, data);
        vm.process(incident);
      } else {
        // When there is no data, it means the incident needs to be refreshed
        // because there was too much data to publish.
        vm.get(incident, true);
      }
    }

    function deletedHandler(data) {
      $window.location.href = '/incidents/';
    }

    function objectAddedHandler(field, data) {
      if (field == 'log') {
        incident.addLogEntry(data);
      } else {
        incident[field].push(data);
      }
      vm.process(incident);
    }

    function objectDeletedHandler(field, data) {
      try {
        var array = incident[field];
        if (field === 'log') {
          incident.removeLogEntry(data);
        } else {
          array.splice(findByEquality(array, data).index, 1);
        }
      } catch (e) {
        $log.error(e);
      };
      vm.process(incident);
    }

    function objectUpdatedHandler(field, data) {
      try {
        angular.merge(findByUUID(incident[field], data.uuid).value, data);
      } catch (e) {
        $log.error(e);
      }
      vm.process(incident);
    }

    function locationContactAddedHandler(data) {
      var locations = JSON.search(
        { locations: incident.locations },
        `//locations[uuid="${data.location_uuid}"]`
      );
      
      delete data.location_uuid;
      locations[0].contacts.push(data);
    }

    function locationContactDeletedHandler(data) {
      var location = JSON.search(
        { locations: incident.locations },
        `//locations[uuid="${data.location_uuid}"]`
      )[0];
      var array = location.contacts;
      try {
        array.splice(findByUUID(array, data.uuid).index, 1);
      } catch (e) {
        $log.error(e);
      };
    }

    function locationContactUpdatedHandler(data) {
      delete data.path;
      var contact = JSON.search(
        incident.locations,
        `//contacts[uuid="${data.uuid}"]`
      )[0];
      angular.merge(contact, data);
    }
  };

  vm.getActive = function ($ctrl, ignoreUpdates) {
    var url = '/api/active-incidents/';
    return $http.get(url).then(getSuccess, getError);

    function getSuccess(response) {
      $ctrl.uuids = response.data;
      if (!ignoreUpdates) subscribeActive($ctrl);
    }

    function getError(response) {
      $log.error(response);
    }
  }

  function subscribeActive($ctrl) {
    var subscribed = false;
    var userChannel;
    var activeChannel = pusher.subscribe('presence-incidents-active');
    activeChannel.$bind('pusher:subscription_succeeded', activeSubscriptionHandler);

    function activeSubscriptionHandler(data) {
      if (!userChannel) {
        userChannel = pusher.subscribe('presence-incidents-user-' + data.myID);
        userChannel.$bind('pusher:subscription_succeeded', userSubscriptionHandler);
        userChannel.$bind('added', addedHandler);
        userChannel.$bind('refresh', refreshHandler);
      }
    }

    function userSubscriptionHandler() {
      if (subscribed) {
        vm.getActive($ctrl, true)
      } else {
        subscribed = true;
        $ctrl.channel = userChannel;
      }
    }

    function refreshHandler() {
      $log.info('Received refresh event for user');
      vm.getActive($ctrl, true);
    }

    function addedHandler(data) {
      $log.info(`New incident with uuid ${data} received!`);
      $ctrl.uuids.unshift(data);
    }
  }
}
